"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'اختيار الوقت'
};
var _default = exports["default"] = locale;